import MobileDrawer from "components/navbar/MobileDrawerv3";
import classes from "components/navbar/NavbarMobile.module.css";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import formatUrl from "utils/FormatUrl";

export default function SearchNavbar({
  openAuthDialog,
  onLogout,
  component,
  displayAnnonce,
  positionRelative,
}: {
  openAuthDialog: () => void;
  onLogout: () => void;
  component: any;
  displayAnnonce?: boolean;
  positionRelative?: boolean;
}) {
  const { t, lang } = useTranslation("LandingPage");
  const router = useRouter();
  const [openDrawer, setOpendrawer] = useState(false);
  const [menuClicked, setMenuClicked] = useState(false);
  const user = useSelector((store: any) => store?.auth?.user);

  const node = useRef(null);

  const handleClickOutside = (event: any) => {
    if (node.current && node.current.contains(event.target)) {
      return;
    }
    setOpendrawer(false);
    setMenuClicked(false);
  };

  // useEffect(() => {
  //     document.addEventListener("click", handleClickOutside);
  //     return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //     };
  // }, []);
  return (
    <>
      <div
        className={`${
          displayAnnonce || positionRelative
            ? classes.navbar__mobile__con
            : classes.navbar__mobile__container
        } ${classes.navbar__mobile__container__annonce}`}
        id={displayAnnonce ? "" : "navbar__mobile__container__annonce"}
        style={
          openDrawer
            ? { position: "fixed", zIndex: "200001" }
            : { position: "relative", zIndex: "100001" }
        }
      >
        <div className={classes.navbar__mobile__inner}>
          <div
            className={classes.navbar__logo__container}
            data-tracking="click"
            data-value="navbar-logo"
          >
            <a
              className={classes.anchor_black}
              href={formatUrl(`/${lang}`, lang)}
            >
              {openDrawer || displayAnnonce ? (
                <span>
                  <svg
                    width="98"
                    height="28"
                    viewBox="0 0 98 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_5698_12543)">
                      <path
                        d="M42.4822 18.505V18.3859C42.2085 18.9544 41.7857 19.4058 41.2139 19.7371C40.6421 20.0694 39.9851 20.2345 39.245 20.2345C37.489 20.2345 36.0557 19.6462 34.944 18.4685C33.8322 17.2907 33.2764 15.7932 33.2764 13.976C33.2764 12.1587 33.8163 10.7082 34.895 9.5305C35.9737 8.35277 37.3836 7.76443 39.1236 7.76443C40.0734 7.76443 40.8231 7.95045 41.3704 8.32142C41.9178 8.69345 42.2798 9.07697 42.4577 9.47093V8.11974H46.009V17.7934C46.009 18.505 46.041 19.2083 46.1059 19.9033H42.578C42.5131 19.5563 42.4811 19.0892 42.4811 18.504L42.4822 18.505ZM36.9736 14C36.9736 14.9489 37.2356 15.7075 37.7584 16.276C38.2813 16.8445 38.9383 17.1298 39.7274 17.1298C40.5164 17.1298 41.149 16.8497 41.6718 16.2875C42.1947 15.7264 42.4566 14.9635 42.4566 14C42.4566 13.0365 42.1989 12.2569 41.6835 11.7114C41.1681 11.1659 40.5154 10.8932 39.7263 10.8932C38.9372 10.8932 38.2408 11.1618 37.7328 11.6989C37.226 12.236 36.9715 13.0031 36.9715 13.999L36.9736 14ZM47.3944 20.5679L50.6316 19.6671C50.7605 20.2512 51.0544 20.7257 51.5133 21.0893C51.9723 21.453 52.5399 21.6348 53.2171 21.6348C55.1978 21.6348 56.1892 20.6306 56.1892 18.6231V18.0776C55.5928 18.9627 54.5216 19.4058 52.9754 19.4058C51.4292 19.4058 50.0523 18.8603 48.9885 17.7694C47.9258 16.6784 47.3933 15.3115 47.3933 13.6677C47.3933 12.0239 47.9205 10.7312 48.9757 9.60156C50.03 8.47191 51.3632 7.90656 52.9743 7.90656C53.8603 7.90656 54.5844 8.05704 55.1488 8.35695C55.7121 8.65792 56.0987 8.99755 56.3084 9.37688V8.12078H59.8119V18.435C59.8119 20.269 59.272 21.7822 58.1933 22.9756C57.1135 24.169 55.5119 24.7657 53.3854 24.7657C51.7423 24.7657 50.3771 24.3508 49.2899 23.5211C48.2027 22.6913 47.5701 21.7069 47.3933 20.5689L47.3944 20.5679ZM51.7913 15.5654C52.2747 16.0399 52.8945 16.2771 53.6516 16.2771C54.4087 16.2771 55.0242 16.0399 55.5002 15.5654C55.9751 15.091 56.2126 14.4588 56.2126 13.6687C56.2126 12.8787 55.9624 12.2663 55.464 11.7835C54.9646 11.3018 54.3608 11.0604 53.6516 11.0604C52.9424 11.0604 52.3343 11.3018 51.8275 11.7835C51.3206 12.2663 51.0661 12.8944 51.0661 13.6687C51.0661 14.4431 51.3078 15.091 51.7913 15.5654ZM69.844 15.6605L72.913 16.5143C72.6063 17.6053 71.9705 18.5019 71.0047 19.2052C70.0378 19.9085 68.8302 20.2607 67.381 20.2607C65.641 20.2607 64.1629 19.6922 62.9479 18.5531C61.7318 17.4151 61.1238 15.8894 61.1238 13.977C61.1238 12.0646 61.7159 10.6497 62.9 9.49601C64.0841 8.34232 65.4887 7.76548 67.1158 7.76548C68.9836 7.76548 70.4542 8.29948 71.5254 9.36643C72.5967 10.4334 73.1323 11.9152 73.1323 13.8119C73.1323 14.4128 73.1078 14.7838 73.0599 14.9259H64.7007C64.7326 15.5738 65.0148 16.1151 65.5462 16.5498C66.0776 16.9845 66.7058 17.2019 67.431 17.2019C68.6716 17.2019 69.4766 16.6888 69.8472 15.6605H69.844ZM64.7699 12.6018H69.5778C69.5458 12.0646 69.3318 11.5986 68.9378 11.2025C68.5427 10.8075 67.9507 10.61 67.1616 10.61C66.4524 10.61 65.8891 10.8159 65.4706 11.2265C65.051 11.6383 64.8178 12.096 64.7699 12.6018ZM78.2171 13.1473V19.9043H74.5443V8.11974H78.0957V9.47093C78.4013 8.94948 78.873 8.54297 79.5088 8.25036C80.1445 7.95776 80.793 7.81146 81.4532 7.81146C82.8865 7.81146 83.9738 8.25036 84.7149 9.12713C85.4561 10.0039 85.8266 11.1304 85.8266 12.5056V19.9033H82.1539V13.1222C82.1539 12.5056 81.9888 12.0124 81.6587 11.6404C81.3286 11.2694 80.8409 11.0834 80.1967 11.0834C79.6003 11.0834 79.1212 11.2767 78.7591 11.6644C78.397 12.0521 78.216 12.5454 78.216 13.1462L78.2171 13.1473ZM97.3592 19.9043H87.2844V16.7275L92.5758 11.2025H87.4293V8.11974H97.2623V11.0834L91.7292 16.7975H97.3592V19.9033V19.9043Z"
                        fill="#00B4FF"
                      />
                      <path
                        d="M13.8433 0.414886C6.19754 0.414886 0 6.49684 0 14C0 21.5032 6.19754 27.5851 13.8433 27.5851C21.4891 27.5851 27.6866 21.5032 27.6866 14C27.6866 6.49684 21.4891 0.414886 13.8433 0.414886ZM4.83345 18.8342L2.80487 16.8435C2.75588 16.7954 2.75588 16.7181 2.80487 16.67L7.10055 12.4544C7.13569 12.4199 7.15486 12.3729 7.15486 12.3249V8.34337C7.15486 8.27544 7.21024 8.2211 7.27945 8.2211H10.1471C10.2164 8.2211 10.2717 8.27544 10.2717 8.34337V9.11981C10.2717 9.20132 10.3729 9.24208 10.4315 9.1846L13.7571 5.92104C13.806 5.87297 13.8848 5.87297 13.9338 5.92104L18.2316 10.1387C18.2806 10.1868 18.2806 10.2641 18.2316 10.3122L16.2031 12.3029C16.1541 12.351 16.0753 12.351 16.0263 12.3029L13.9338 10.2484C13.8848 10.2003 13.806 10.2003 13.7571 10.2484L5.01021 18.8342C4.96123 18.8823 4.88243 18.8823 4.83345 18.8342ZM23.8531 13.6207L23.3079 13.0856C23.2589 13.0375 23.1801 13.0375 23.1311 13.0856L13.9338 22.1114C13.8848 22.1594 13.806 22.1594 13.7571 22.1114L9.45924 17.8937C9.41026 17.8456 9.41026 17.7683 9.45924 17.7202L11.4878 15.7295C11.5368 15.6814 11.6156 15.6814 11.6646 15.7295L13.7571 17.7829C13.806 17.831 13.8848 17.831 13.9338 17.7829L20.9268 10.9204C20.9758 10.8723 20.9758 10.795 20.9268 10.7469L20.3816 10.2118C20.3284 10.1596 20.3571 10.0697 20.4306 10.0561L24.6688 9.30373C24.7327 9.29224 24.7891 9.34762 24.7774 9.41032L24.0107 13.5695C23.9968 13.6426 23.9063 13.6708 23.852 13.6175L23.8531 13.6207Z"
                        fill="#00B4FF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_5698_12543">
                        <rect
                          width="97.36"
                          height="27.1702"
                          fill="white"
                          transform="translate(0 0.414886)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              ) : (
                <span>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.7366 0.141113C6.59842 0.141113 0 6.79321 0 15C0 23.2067 6.59842 29.8588 14.7366 29.8588C22.8749 29.8588 29.4733 23.2067 29.4733 15C29.4733 6.79321 22.8759 0.141113 14.7366 0.141113ZM5.14583 20.2869L2.9872 18.1104C2.93528 18.058 2.93528 17.9732 2.9872 17.9209L7.55988 13.3103C7.59726 13.2726 7.61803 13.2213 7.61803 13.1679V8.81271C7.61803 8.73838 7.67721 8.6787 7.75093 8.6787H10.8046C10.8783 8.6787 10.9375 8.73838 10.9375 8.81271V9.66176C10.9375 9.75074 11.0444 9.79576 11.1078 9.73295L14.6473 6.16401C14.6993 6.11167 14.7834 6.11167 14.8353 6.16401L19.41 10.7767C19.462 10.8291 19.462 10.9139 19.41 10.9662L17.2514 13.1427C17.1995 13.1951 17.1154 13.1951 17.0635 13.1427L14.8353 10.8961C14.7834 10.8437 14.6993 10.8437 14.6473 10.8961L5.3348 20.2858C5.28185 20.3392 5.19775 20.3392 5.14583 20.2869ZM25.3927 14.5844L24.8123 13.9991C24.7604 13.9468 24.6763 13.9468 24.6244 13.9991L14.8332 23.8715C14.7813 23.9239 14.6972 23.9239 14.6453 23.8715L10.0715 19.2588C10.0196 19.2065 10.0196 19.1217 10.0715 19.0693L12.2302 16.8928C12.2821 16.8405 12.3662 16.8405 12.4181 16.8928L14.6463 19.1395C14.6982 19.1918 14.7823 19.1918 14.8342 19.1395L22.2789 11.6341C22.3308 11.5818 22.3308 11.497 22.2789 11.4447L21.6985 10.8594C21.6413 10.8018 21.6725 10.7045 21.7514 10.6898L26.2639 9.86695C26.3324 9.85439 26.3916 9.91511 26.3791 9.98316L25.563 14.5331C25.5464 14.6116 25.4498 14.6419 25.3927 14.5844Z"
                      fill="#00B4FF"
                    />
                  </svg>
                </span>
              )}
            </a>
          </div>
          {openDrawer ? <></> : component}
          <div className={classes.navbar__mobile__right__container}>
            <div className={classes.navbar__mobile__right__inner}>
              <div
                className={classes.navbar__mobile__button__container}
                onClick={() => {
                  setOpendrawer(!openDrawer);
                  setMenuClicked(!menuClicked);
                }}
              >
                <div
                  className={classes.navbar__mobile__button__inner}
                  data-tracking="click"
                  data-value="navbar-mobile-menu-logo"
                >
                  {openDrawer ? (
                    <i
                      aria-hidden
                      className={`fas fa-times ${classes.fa__times}`}
                    ></i>
                  ) : (
                    <i
                      aria-hidden
                      className={`fas fa-bars ${classes.fa__bars}`}
                    ></i>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {true && (
        <>
          <div
            className={menuClicked ? classes.connav : classes.connavnone}
            style={{
              top: 0,
              left: 0,
            }}
            onClick={handleClickOutside}
          ></div>
          <MobileDrawer
            user={user}
            closeMenu={() => {
              setMenuClicked(false);
              setOpendrawer(false);
            }}
            openLoginModal={() => {
              openAuthDialog();
            }}
            onLogout={onLogout}
            menuClicked={menuClicked}
          />
          {/* <SideBarMobile route="PRO_SPACE_CONTACTS" /> */}
        </>
      )}
    </>
  );
}
